const baseURL = "https://ec-devices.com";
console.log('baseURL: ' + baseURL)
export { baseURL };

